import { useAtomValue } from "jotai";
import { useLocation } from "react-router-dom";
import { isActiveUserEngineerStudioManagerOrArtistAtom } from "../../../atoms/user/activeUserAtom";
import { useMediaQueryBreakpoint } from "../../../hooks/useMediaQuery";
import { SCREENS } from "../../../routes/screens";
import { useAppSelector } from "../../../store/hooks";
import { isUserVerifiedAdminSelector } from "../../../store/selectors/userInfoSelectors";
import {
  SitewideSearchBar,
  SitewideSearchBarVariant,
} from "../../core-ui/components/SitewideSearchBar/SitewideSearchBar";
import { NavigationRow } from "../Navigation/NavigationRow/NavigationRow";
import { NavLoginContainer } from "../Navigation/NavLoginContainer/NavLoginContainer";
import { NavProfileMenu } from "../Navigation/NavProfileMenu/NavProfileMenu";
import "./LoggedInHeaderContent.css";

export const LoggedInHeaderContent = () => {
  const user = useAppSelector((state) => state.accountInfo.user);
  const isEngineerStudioManagerOrArtist = useAtomValue(
    isActiveUserEngineerStudioManagerOrArtistAtom,
  );
  const { isMobile, isTablet } = useMediaQueryBreakpoint();
  const { pathname } = useLocation();
  const userIsAdmin = useAppSelector(isUserVerifiedAdminSelector);

  const showSearchBar =
    pathname !== SCREENS.SEARCH &&
    pathname !== SCREENS.SIGNED_OUT_HOME_SCREEN &&
    pathname !== SCREENS.SIGN_IN_SCREEN &&
    pathname !== SCREENS.SIGN_UP_SCREEN &&
    pathname !== SCREENS.PAGINATED_ENGINEERS &&
    pathname !== SCREENS.PAGINATED_STUDIOS &&
    !isMobile;

  return (
    <div className="app-bar-content-container" style={{ marginLeft: "auto" }}>
      <div className="center-nav-section">
        <NavigationRow
          isAdmin={userIsAdmin}
          isEngineerStudioManagerOrArtist={isEngineerStudioManagerOrArtist}
          user={user}
          path={pathname}
        />
        {showSearchBar && (
          <SitewideSearchBar variant={SitewideSearchBarVariant.NAVBAR} />
        )}
      </div>
      <div className="logged-in-header-container">
        {!isMobile && user && (
          <>
            <NavProfileMenu user={user} />
          </>
        )}
        {!user && <NavLoginContainer showSignUpButton={!isTablet} />}
      </div>
    </div>
  );
};
